import * as React from 'react';
import { InputLabel as MuiInputLabel } from '@material-ui/core';

var InputLabel = function InputLabel(_ref) {
  var children = _ref.children,
      htmlFor = _ref.htmlFor,
      label = _ref.label;
  return /*#__PURE__*/React.createElement(MuiInputLabel, {
    htmlFor: htmlFor,
    variant: "outlined"
  }, children, label);
};

export default InputLabel;

try {
  InputLabel.__docgenInfo = {
    description: '',
    displayName: 'InputLabel',
    methods: [],
    props: {
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: false,
        type: {
          name: 'string'
        }
      },
      htmlFor: {
        defaultValue: null,
        description: '',
        name: 'htmlFor',
        required: false,
        type: {
          name: 'string'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map